import { css } from '@emotion/css';

export const stySuccessWrapper = css`
  display: flex;
  flex-flow: column;
  text-align: center;
`;

export const styTextTitle = css`
  font-weight: 700;
  font-size: 20px;
`;

export const styTextContent = css`
  font-weight: 700;
  font-size: 14px;
`;
